import React, { useState } from "react";
import styled from "styled-components";
import { color } from "../Utils/Constant";
import { BiSolidContact } from "react-icons/bi";
import { FaLocationDot,FaEnvelopeOpenText  } from "react-icons/fa6";
import { MdOutlineQrCodeScanner } from "react-icons/md";
import Contact from "./Contact";
import Location from "./Location";
import QRCodeComp from "./QRCodeComp";
import EnquiryForm from "./EnquiryForm";


// styles
const NavButtonsContainer = styled.div`
  background-color: ${color.primary};
  margin-top: 20px;
  padding: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;
const NavButtons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.active ? color.white : color.inactive_tab)};
  cursor: pointer;
  gap: 10px;
  &:hover {
    color: ${color.white};
  }
`;
const StyledIcon = styled.div`
  font-size: 25px;
`;
const ButtonText = styled.p`
  font-size: 12px;
  font-weight: 400;
`;

const Body = () => {
  const [activeTab, setActiveTab] = useState(1);
  return (
    <>
      <NavButtonsContainer>
        {/* contact details icon */}
        <NavButtons active={activeTab === 1} onClick={() => setActiveTab(1)}>
          <StyledIcon as={BiSolidContact} />
          <ButtonText>CONTACT</ButtonText>
        </NavButtons>
        {/* location details icon */}
        <NavButtons active={activeTab === 2} onClick={() => setActiveTab(2)}>
          <StyledIcon as={FaLocationDot} />
          <ButtonText>LOCATION</ButtonText>
        </NavButtons>
        {/* QR code */}
        <NavButtons active={activeTab === 3} onClick={() => setActiveTab(3)}>
          <StyledIcon as={MdOutlineQrCodeScanner} />
          <ButtonText>QR CODE</ButtonText>
        </NavButtons>
        {/* Enquiry  */}
        <NavButtons active={activeTab === 4} onClick={() => setActiveTab(4)}>
          <StyledIcon as={FaEnvelopeOpenText } />
          <ButtonText>ENQUIRY</ButtonText>
        </NavButtons>
      </NavButtonsContainer>
      {activeTab === 1 && <Contact />}
      {activeTab === 2 && <Location />}
      {activeTab === 3 && <QRCodeComp />}
      {activeTab === 4 && <EnquiryForm />}
    </>
  );
};

export default Body;
